import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M12 6C15.79 6 19.17 8.13 20.82 11.5C19.17 14.87 15.79 17 12 17C8.21 17 4.83 14.87 3.18 11.5C4.83 8.13 8.21 6 12 6ZM12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 9C13.38 9 14.5 10.12 14.5 11.5C14.5 12.88 13.38 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 10.12 10.62 9 12 9ZM12 7C9.52 7 7.5 9.02 7.5 11.5C7.5 13.98 9.52 16 12 16C14.48 16 16.5 13.98 16.5 11.5C16.5 9.02 14.48 7 12 7Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 3.93506C4.97627 3.93506 2.98018 5.8657 1.99951 7.73789L1.86218 8.00006L1.99951 8.26222C2.98018 10.1344 4.97627 12.0651 8 12.0651C11.0237 12.0651 13.0198 10.1344 14.0005 8.26222L14.1378 8.00006L14.0005 7.73789C13.0198 5.8657 11.0237 3.93506 8 3.93506ZM8 10.9351C5.65705 10.9351 4.03537 9.53013 3.14532 8.00006C4.03537 6.46999 5.65705 5.06506 8 5.06506C10.343 5.06506 11.9646 6.46999 12.8547 8.00006C11.9646 9.53012 10.343 10.9351 8 10.9351ZM8.87 8C8.87 8.48049 8.48049 8.87 8 8.87C7.51951 8.87 7.13 8.48049 7.13 8C7.13 7.51951 7.51951 7.13 8 7.13C8.48049 7.13 8.87 7.51951 8.87 8ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z"
  />
);

export const VisibilityIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Visibility" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
